/**
 * Instagram hook
 * Hooks are used to compose and re-use blocks of functionality
 */

// Import statements
import {graphql, useStaticQuery} from "gatsby"
import {getImage} from "gatsby-plugin-image"

/**
 * Create an re-usable Instagram hook
 * @returns {*}
 */
const useInstagram = () => {

    // query for latest 6 Instagram posts
    const data = useStaticQuery(graphql`
    query {
      allInstagramContent {
        nodes {
          id
          caption
          media_url
          localFile {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED,
                placeholder: NONE,
                width: 250,
                aspectRatio: 1
              )
            }
          }
          permalink,
        }
      }
    }
  `)

  // return the posts in an map
  return data.allInstagramContent.nodes.map(node => ({
      image: getImage(node.localFile),
      id: node.id,
      caption: node.caption,
      permalink: node.permalink,
  }))
}

/**
 * Export instagram hook constant
 */
export default useInstagram